import * as enums from '@worldfavor/constants/enums'

(function() {
    'use strict'
	
    angular
        .module('wf.common')
        .component('wfMaterialityAnalysis', {
            templateUrl: 'scripts/wf/materialityAnalysis/wfMaterialityAnalysis.component.html',
            controller: wfMaterialityAnalysisController,
            controllerAs: 'vm',
            bindings: {
                ticket: '<',
                item: '<',
                allowExpanding: '<',
                landingPageVm: '<',
                disableAddingToScope: '<',
                scopeCategoryId: '<',
                configFromAttribute: '<config',
            },
        })

    wfMaterialityAnalysisController.$inject = ['$scope', '$timeout', '$element', '$rootScope', '$state', 'requirements', '$transclude', '$compile', '$translate', '$q', 'dataOperationsService', 'wfObject', 'statisticsService', 'analyzeService', 'DataNegotiator', 'wfAuth', 'apiProxy', 'modalService', '$uibModal', 'dataQuery']
    function wfMaterialityAnalysisController($scope, $timeout, $element, $rootScope, $state, requirementService, $transclude, $compile, $translate, $q, dataOps, wfObject, statisticsService, analyzeService, DataNegotiator, wfAuth, apiProxy, modal, $uibModal, dataQuery) {
        const
            vm = this
			
        let lookups
			
        let negotiator
			
        let linkageXhrRequest
			
        let linkageLoader
			
        const culture = wfAuth.getCulture()
			
        const linkage = {
            loadedItems: [],
        }
			
        let organizations
			
        let organizationIds
			
        const networkId = 91
			
        let filteredOrgCount = 0
			
        let organizationChunckSize = 50
			
        let orgIdsLeftToLoad = []
			
        const limitGriItemIds = [10674, 10673, 10688, 10690, 10698, 10701, 10703, 10740, 10742, 10770, 10772, 10774, 10806, 11070, 11091, 11096, 11100, 11106, 11150, 11213]
			
        const useIndustries = true
			
        let authOrgIndustryWfids

        // Used to store loaded raw GRI Disclosure items before grouping them.
        // When loading data in batches each response gets merged with this array and given to the negotiator as the result it will use.
			
        const negotiatorResultBeforeGrouping = []

        this.$onInit = $onInit

        const orgIdsResult = []

        function $onInit() {
            _.assign(vm, {
                defaultLimit: 10,
                maxLimit: 15,
                initialLoaded: false,
                allChunksLoaded: false,
                loaderBarShown: true,
                filteredOrganizationIds: [],
                emptyState: false,
                isListLimited: true,
                applyIeStyles: $.browser.msie,
                // filteredOrganizationIds: [ 18796, 123441, 108798, 52410, 16884, 21762, 52404, 43211, 51145, 16029, 21969, 7730, 35355, 45243, 48110, 42390, 41797, 8070, 43343, 7613, 38835, 7673, 25317, 7899, 44500, 34734, 37797, 24471, 12415, 8105, 42359, 46100, 35626, 22182, 10294, 41897, 44101, 29435, 6111, 23821, 44696, 44796, 29100, 6064, 5120, 28324, 22954, 20266, 41503, 47134, 48028, 49485, 52377, 39815, 109275, 120774, 54135, 123183, 31372, 9472, 120666, 5088, 9501, 49178, 7061, 109109, 43653, 123184, 47437, 46196, 36751, 23309, 33614, 5889, 36611, 30901, 44817, 14766, 30767, 46061, 6636, 41700, 15146, 7328, 34986, 26194, 109290, 120891, 120611, 7437, 20079, 109276, 49422, 48268, 42570, 120456, 38195, 48360, 24795, 41983, 42170, 39484, 36350, 123284, 16106, 35235, 123285, 32601, 8928, 7699, 123286, 22993, 48066, 42257, 47823, 19298, 38076, 120617, 53346, 17856, 22963, 34511, 16045, 48434, 38811, 37268, 123287, 120960, 16146, 15306, 43008, 5879, 30249, 10097, 40370, 44816, 19804, 30210, 32975, 35239, 120599, 52973, 18987, 25311, 15177, 109289, 8187, 47657, 30344, 109207, 19920, 40656 ],
                // filteredOrganizationIds: [ 52410,16884,21762,52404,43211,51145,16029,21969,7730,35355,45243,48110,42390,41797,8070,43343,7613,38835,7673,25317,7899,44500,34734,18796,37797,24471,12415,8105,42359,46100,35626,22182,10294,41897,44101,108798,29435,6111,23821,44696,44796,29100,6064,5120,28324,22954,20266,41503,47134,48028,49485,52377,39815,109275,120774,54135,123183,31372,9472,120666,5088,9501,49178,7061,109109,43653,123184,47437,46196,36751,23309,33614,5889,36611,30901,44817,14766,30767,46061,6636,41700,15146,7328,34986,26194,109290,120891,120611,7437,20079,109276,49422,48268,42570,120456,38195,48360,24795,41983,42170,39484,36350,123284,16106,35235,123285,32601,8928,7699,123286,22993,48066,42257,47823,19298,38076,120617,53346,17856,22963,34511,16045,48434,38811,37268,123287,120960,16146,15306,43008,5879,30249,10097,40370,44816,19804,30210,32975,35239,120599,52973,18987,25311,15177,109289,8187,47657,30344,109207,19920,40656,46712,30412,36739,51389,13191,17397,52390,123289,41682,8121,28555,120765,14656,5456,41875,19766,120961,40444,108807,47132,40113,24369,12249,18380,34798,31610,14050,46042,123018,15959,109288,123290,51075,21639,21312,32917,25281,34142,33078,26654,109300,23701,108808,52046,32805,13243,24347,32946,109297,25327,49321,120917,109302,123294,51283,15120,44564,25513,10334,8677,52002,34387,30839,14579,28803,11720,48093,11308,9656,39039,34908,120088,42774,53131,9581,123295,120798,34861,47996,38056,46836,33393,120698,22953,14462,39903,34877,12462,48651,17372,41971,27185,120694,18221,9053,34011,47384,17610,120905,44290,123336,120693,34003,20364,7063,14650,39949,123361,22804,108802,25309,31178,29998,31428,31157,34358,35274,35602,123362,108814,120924,40514,46822,46387,49659,123363,6415,7336,7775,7977,8623,12572,12598,123364,14867,28697,18835,18469,27961,28737,30431,108803,33315,28698,37119,120893,37555,38451,123371,44117,44224,44682,123372,43440,43059,108827,46356,108806,46169,46232,51086,50706,50850,33306,10874,13292,108801,16979,123375,26063,123376,123377,123378,34136,6625,9223,123387,123388,38246,109304,123389,123390,123391,123392,25486,123393,123394,123395,109316,28183,33074,34831,123403,35268,36032,123404,18851,120928,40648,123405,123411,123413,123414,23003,5467,31884,123440,7430,123441 ],
                networkId,
                isWorkMode: true,
                showIndustriesInLoaderBar: true,

                scopeCategoryWfid: undefined,
                scopeCategorySubItemsKind: enums.subItemsKind.childrenByUser,

                itemsComparedWithScope: false,
                getItemPosition,
                openGuidance,
                toggleListLimit,
                toggleLoaderBar,
                addOrRemoveFromScopeCategory,
            })

            vm.actualLimit = vm.defaultLimit

            if (vm.configFromAttribute) {
                _.assign(vm, vm.configFromAttribute)
            }

            vm.scopeCategoryWfid = '71-' + (vm.scopeCategoryId || enums.ids.scopeDashboard.privateScope)

            if (vm.ticket && vm.ticket.organizationId && vm.ticket.organizationId !== wfAuth.getOrganizationId()) {
                vm.isWorkMode = false
                vm.showIndustriesInLoaderBar = false
                vm.maxLimit = 20
            }
			
            $('body').addClass('lift-intercom-button')
            $scope.$on('$destroy', () => {
                if (vm.loaderBarShown) toggleLoaderBar()
            })

            loadInitialData().then(() => {
                setupFilteringConfig()
				
                defineLookupObjects().then(() => {
                    initNegotiatorAndLinkageLoder()

                    if (useIndustries) vm.filteredOrganizationIds = _.map(getOrganizationInIndustries(), 'id')
                    else vm.filteredOrganizationIds = _.clone(_.map(organizations, 'id'))

                    syncAggregatedDataView()
                })

                if (!vm.landingPageVm && !vm.allowExpanding) console.error('Please make sure to pass landingPageVm in order to have contactForm in the materiality page')
            })
        }

        function loadInitialData() {
            return $q((resolve) => {
                dataOps.getSubItems('71-14409', enums.subItemsKind.childrenByUser, { bypassCache: true, ticket: vm.ticket }).then((res) => { // Selected industries of the current organization
                    authOrgIndustryWfids = _.map(res, 'wfcid')
                    vm.mainOrgIndustries = _.map(res, 'childContent')

                    // valueChainService.loadOrganizationsInNetwork(networkId, true).then(function(res) {
                    const tempOrgs = [46712, 16884, 21762, 52404, 51145, 41983, 42390, 43343, 7613, 44500, 34734, 42359, 46100, 22182, 41897, 29435, 23821, 5120, 123183, 6064, 48028, 39815, 9501, 43653, 33614, 30901, 44817, 34986, 26194, 49422, 123018, 7699, 48066, 37268, 15306, 18987, 109207, 8121, 5456, 41875, 40444, 108807, 51075, 21639, 33078, 32805, 49321, 51283, 25513, 34387, 28803, 11308, 9656, 120088, 12462, 48651, 27185, 18221, 34011, 44290, 120693, 34003, 20364, 19766, 123336, 22804, 31178, 29998, 35602, 40514, 46042, 46387, 7977, 8623, 12572, 14867, 18835, 27961, 30431, 28698, 37555, 44224, 43440, 108827, 46356, 46169, 46232, 50706, 33306, 13292, 16979, 26063, 123377, 34136, 123387, 123388, 38246, 123389, 123390, 123391, 25486, 123393, 123394, 123395, 109316, 33074, 34831, 35268, 36032, 18851, 120928, 123411, 123413, 123414, 123404, 23003, 5467, 109276, 7430, 123442, 123443, 123444, 123445, 123446, 5265, 28211, 123461, 123462, 40635, 123463, 123464, 32980, 34833, 123465, 123466, 47025, 13064, 123467, 123468, 123469, 123470, 123471, 123472, 123473, 123474, 123497, 123498, 123499, 123500, 42452, 123501, 123502, 123503, 123504, 123505, 123506, 123507, 45383, 123508, 8498, 19644, 44192, 123509, 42849, 123510, 123511, 123512, 123513, 123514, 44694, 123515, 123516, 123517, 123518, 53111, 123544, 14485, 123545, 123546, 123547, 10294, 123549, 123550, 123551, 123552, 37271, 123553, 123554, 44101, 123555, 123557, 123558, 123559, 123560, 123561, 123562, 123563, 123564, 123565, 123566, 123567, 123569, 19457, 13182, 123571, 123573, 123574, 123575, 50586, 123576, 120948, 123577, 123578, 123579, 18621, 123580, 26435, 123581, 123582, 123583, 123584, 123585, 123586, 123587, 123588, 123589, 23099, 123590, 123591, 123592, 123593, 123594, 123595, 123597, 25127, 36008, 123598, 123599, 123600, 123601, 123602, 123603, 123604, 14495, 123605, 17856, 14676, 24793, 31879, 123645, 123646, 52511, 123647, 123648, 123649, 123650, 123651, 123652, 123653, 123654, 123655, 123656, 30611, 123657, 123659, 123660, 123661, 123662, 53236, 123663, 123664, 123665, 123671, 123672, 123673, 10523, 123756, 123757, 13638, 38430, 26438, 23594, 123845, 123847, 123848, 123850, 123857, 123858, 123885, 123886, 123888, 123889, 123890, 123891, 123892, 123893, 123896, 5253, 44699, 109123, 123898, 123899, 123900, 123901, 124023, 124028, 124029, 124032, 124036, 124037, 123658, 123376, 120891, 108808, 47996, 46822, 43059, 124117, 124118, 124119, 124121, 124122, 124123, 124124, 124131, 124133, 124134, 124135]
                    // organizations = _.map(res, "childContent");
                    // organizationIds = vm.filteredOrganizationIds = _.map(organizations, "id");
                    organizations = _.map(tempOrgs, (orgId) => {
                        return {
                            type: 101,
                            id: orgId,
                            wfid: '101-' + orgId,
                        }
                    })
                    organizationIds = tempOrgs

                    resolve()
                    // });
                })
            })
        }

        function initNegotiatorAndLinkageLoder() {
            const
                params = {
                    inject: false,
                    fromItem: { type: enums.objectType.structure, id: 17645 },
                    ticket: { networkId: vm.networkId, organizationIds: vm.filteredOrganizationIds },
                    mainHierarchyKind: enums.subItemsKind.children,
                    usePlaceholderLoaders: false,
                    loadOnInit: false,
                    loadDepth: 0,
                    loadParents: false,
                    loadMetadata: false,
                    loadVisibilityTags: false,
                    includeStatistics: false,
                    hooks: {
                        beforeItemCompositesCreation(relations) {
                            relations = _.filter(relations, (relation) => {
                                return lookups.includeItemsInCategoryByWfid[lookups.categoryWfidByGriWfid[relation.wfcid]]
                            })

                            // Uncomment below to limit result
                            // relations = _.filter(relations, function (relation) {
                            // 	return !!!~limitGriItemIds.indexOf(relation.childId);
                            // });
							
                            Array.prototype.push.apply(negotiatorResultBeforeGrouping, relations)

                            return _.chain(negotiatorResultBeforeGrouping)
                                .groupBy('wfcid')
                                .mapValues((groupRelations, key) => {
                                    const output = _.find(groupRelations, (relation) => {
                                        return relation.childContent
                                    })

                                    if (!output) return

                                    output.metadata = {
                                        statistics: {
                                            groupCount: groupRelations.length,
                                        },
                                    }

                                    output.settings = {
                                        uiSettings: { hideMetadata: true },
                                    }

                                    delete output.createdAt
                                    delete output.creatorOrganization
                                    delete output.creatorUser

                                    return output
                                })
                                .map()
                                .orderBy('metadata.statistics.groupCount', 'desc')
                                .value()
                        },
                    },
                }

            linkageLoader = dataOps.linkageLoader({
                limit: ['71-387'],
                loadParents: true,
                preloadedLinkageRelationalMap: lookups.sdgLinkageByGriWfid,
                groupBySource: false,
            })
            negotiator = vm.negotiator = new DataNegotiator(params)

            negotiator.onRequest.then(onGriLoaded)

            $scope.$watchCollection('vm.negotiator.viewItems', () => {
                linkageLoader.loadLinkage(vm.negotiator.viewItems)
                // if (vm.allChunksLoaded) {
                // 	vm.allChunksLoaded = false;
                // 	vm.viewItemsChangingAnimation = true;
                // 	$timeout(function () {
                // 		vm.allChunksLoaded = true;
                // 		vm.viewItemsChangingAnimation = false;
                // 	}, 900);
                // }
            })

            linkageLoader.onLoaded(onLinkageLoaded)

            function onLinkageLoaded(linkageItems) {
                let
                    preparedItems

                _.each(linkageItems, (linkageItem) => {
                    linkageItem.goalWfid = lookups.categoryWfidBySdgWfid[linkageItem.wfid]
                    linkageItem.goal = lookups.sdgCategoriesByWfid[lookups.categoryWfidBySdgWfid[linkageItem.wfid]]
                })

                preparedItems = _.chain(linkageItems).map((linkageItem) => {
                    const
                        percentage = _.round((linkageItem.count / filteredOrgCount) * 100.0, 10)
						
                    let multiplyFactor = 1.0

                    _.each(linkageItem.forItems, (itemComposite) => {
                        multiplyFactor *= (itemComposite.percentage / 100.0)
                    })

                    // console.log(linkageItem.count, multiplyFactor, linkageItem.count * multiplyFactor, linkageItem.title);

                    return {
                        title: linkageItem.title,
                        description: linkageItem.description,
                        content: linkageItem.content,
                        goal: linkageItem.goal,
                        goalWfid: linkageItem.goalWfid,
                        count: linkageItem.count,
                        percentage,
                        weightedPercentage: linkageItem.count * multiplyFactor * 100.0,
                        wfid: linkageItem.wfid,
                        orderValue: linkageItem.count * multiplyFactor,
                    }
                }).orderBy('orderValue', 'desc').value()

                vm.sdgItems = preparedItems
                vm.filteredSdgItems = []

                vm.linkageGoals = _.chain(preparedItems).groupBy('goalWfid')
                    .mapValues((linkageItems) => {
                        const goal = _.clone(linkageItems[0].goal)
                        goal.sdgTargets = _.chain(linkageItems).keyBy('wfid').map().value()
                        goal.targetsCount = goal.sdgTargets.length
                        goal.orderValue = _.sum(goal.sdgTargets, 'weightedPercentage')
                        return goal
                    })
                    .map()
                    .orderBy('orderValue', 'desc')
                    .take(5)
                    .value()

                vm.linkageItemsByGriWfid = _.groupBy(linkageItems, 'forItem.wfid')
                vm.linkageGoalsByGriWfid = _.chain(vm.linkageItemsByGriWfid).mapValues((linkageItems) => {
                    const output = _.chain(linkageItems)
                        .groupBy('goalWfid')
                        .mapValues((linkageItems) => {
                            const goal = _.clone(linkageItems[0].goal)
                            goal.sdgTargets = linkageItems
                            return goal
                        })
                        .map()
                        .sort((a, b) => {
                            return natsort()(a.title, b.title)
                        })
                        .value()
                    return output
                })
                    .value()

                $timeout()
            }

            function onGriLoaded() {
                const
                    items = negotiator.items
					
                let prepatedItems
					
                let orgIdsToLoad

                if (orgIdsLeftToLoad.length) {
                    orgIdsToLoad = orgIdsLeftToLoad.splice(0, organizationChunckSize)
                    if (orgIdsToLoad.length) negotiator.loadItemsFromServer({ ticket: { networkId, organizationIds: orgIdsToLoad } })
                    else {
                        if (!vm.disableAddingToScope) checkIfItemsBelongToScopeCategory()
                        vm.allChunksLoaded = true
                    }
                }
                else {
                    if (!vm.disableAddingToScope) checkIfItemsBelongToScopeCategory()
                    vm.allChunksLoaded = true
                }
	
                // // Remove 'Core' disclosures
                // items = _.filter(items, function (item) {
                // 	return !_.includes(item.mainTextual, "(Core)");
                // });
	
                prepatedItems = _.chain(items).map((itemComposite) => {
                    const
                        groupCount = _.get(itemComposite, 'dataRelation.metadata.statistics.groupCount')
						
                    const percentage = _.round((groupCount / filteredOrgCount) * 100.0, 10)
	
                    itemComposite.count = groupCount
                    itemComposite.percentage = percentage
                    itemComposite.color = lookups.griColorsByWfid[lookups.categoryWfidByGriWfid[itemComposite.wfid]]
                    itemComposite.griCategoryTitle = lookups.griCategoriesByWfid[lookups.categoryWfidByGriWfid[itemComposite.wfid]]
                    itemComposite.griCode = lookups.griCodeByWfid[lookups.categoryWfidByGriWfid[itemComposite.wfid]]
					
                    return itemComposite
                }).orderBy('groupCount', 'desc').value()
	
                // Load linkage
                linkageLoader.loadLinkage(vm.negotiator.viewItems)
	
                vm.griItems = prepatedItems

                // Array.prototype.push.apply(orgIdsResult, _.map(_.filter(negotiatorResultBeforeGrouping, { childId: 11096 }), "organizationId"));

                // orgIdsResult = _.uniq(orgIdsResult);

                if (vm.griItems.length === 0) {
                    vm.sdgItems = []
                    vm.filteredSdgItems = []
                    $timeout()
                    $timeout(() => {
                        vm.initialLoaded = true
                    }, 500)
                    // console.log(orgIdsResult);
                }
                else {
                    // console.log(orgIdsResult);
                    vm.initialLoaded = true
                    $timeout()
                }
            }
        }

        function syncAggregatedDataView() {
            negotiator = vm.negotiator
			
            if (negotiator.xhrRequest) negotiator.xhrRequest.abort()

            if (vm.filteredOrganizationIds.length > 1) {
                orgIdsLeftToLoad = vm.filteredOrganizationIds
                filteredOrgCount = vm.filteredOrganizationIds.length
                negotiatorResultBeforeGrouping.length = 0
	
                organizationChunckSize = Math.ceil(filteredOrgCount / 5)
                if (organizationChunckSize < 1) organizationChunckSize = 1
	
                negotiator.loadItemsFromServer({ ticket: { networkId, organizationIds: orgIdsLeftToLoad.splice(0, organizationChunckSize) } })
            }
            else {
                vm.emptyState = true
                vm.initialLoaded = true
                vm.allChunksLoaded = true
            }
        }

        function toggleListLimit() {
            if (vm.isListLimited) vm.actualLimit = vm.maxLimit
            else vm.actualLimit = vm.defaultLimit

            vm.isListLimited = !vm.isListLimited
        }

        function getOrganizationInIndustries() {
            const filteredIndustryRelations = _.chain(vm.industryRelations)
                .filter((relation) => {
                    return _.includes(authOrgIndustryWfids, relation.wfcid)
                })
                .value()

            const items = _.intersectionWith(organizations, filteredIndustryRelations, (org, relation) => {
                return org.id === relation.organizationId
            })

            return items

        }

        function openGuidance(item) {
            if (!item) return

            const templateHtml =
				'<div class="guidance-explanation"><i class="fa fa-info-circle"></i><span>' + $translate.instant('modules.materialityAnalysis.guidanceExplanationText') + '</span></div>' +
				'<div class="modal-header">' +
					'<button type="button" class="bootbox-close-button close" wf-click="$close()" aria-hidden="true">×</button>' +
					'<h3 class="modal-title">' + item.title + '</h3>' +
				'</div>' +
				'<div class="modal-body">' +
					'<div class="message">' + item.guidance + '</div>' +
				'</div>' +
				'<div class="modal-footer">' +
					'<button class="btn wf-btn-link" wf-click="$close()">' + $translate.instant('Close') + '</button>' +
				'</div>'

            $uibModal.open({
                animation: true,
                size: 'width-700',
                windowClass: 'guidance gri-guidance-modal',
                backdrop: 'static',
                template: templateHtml,
            })
        }

        function getItemPosition(index, item) {
            console.log(index)
        }

        function setupFilteringConfig() {
            vm.griFilteringConfig = {
                filters: [
                    // [ { bySearch: true } ],
                    [{
                        // headerTranslate: "GRI Standards",
                        single: true,
                        canClearAll: false,
                        filterOptionsSource(sourceArray) {
                            let output

                            output = _.chain(sourceArray).map((item) => {
                                item.topCategoryWfid = lookups.categoryWfidByGriWfid[item.wfid]
                                return item
                            }).groupBy('topCategoryWfid').mapValues((items, topCatWfid) => {
                                const output = {
                                    title: lookups.griCategoriesByWfid[topCatWfid], // + (" " + items.length + "/" + lookups.totalCountByCatWfid[topCatWfid]),
                                    id: topCatWfid,
                                    count: items.length,
                                    items,
                                    cssClass: lookups.griCategoryCssClassesByWfid[topCatWfid],
                                }
			
                                // output.percentage = Math.trunc((output.uniquePickedInCategory / output.totalCount * 100.0)) + "%";
			
                                return output
                            }).map().sortBy('title').value()

                            return output
                        },
                    },
                    ],
                ],
            }

            vm.sdgFilteringConfig = {
                onFiltered(filteredItems) {
                    vm.filteredSdgItems = filteredItems
                    $timeout()
                },
                filters: [
                    [{ bySearch: true }],
                    [{
                        headerTranslate: 'SDG Goals',
                        filterOptionsSource(sourceArray) {
                            let output

                            output = _.chain(sourceArray).map((item) => {
                                item.topCategoryWfid = lookups.categoryWfidBySdgWfid[item.wfid]
                                return item
                            }).groupBy('topCategoryWfid').mapValues((items, topCatWfid) => {
                                const sdgGoal = lookups.sdgCategoriesByWfid[topCatWfid]
                                const output = {
                                    content: sdgGoal,
                                    title: sdgGoal.title,
                                    id: topCatWfid,
                                    count: items.length,
                                    items,
                                }
			
                                // output.percentage = Math.trunc((output.uniquePickedInCategory / output.totalCount * 100.0)) + "%";
			
                                return output
                            }).map().value().sort((a, b) => {
                                return natsort()(a.title, b.title)
                            })

                            return output
                        },
                    },
                    ],
                ],
            }

            vm.orgFilteringConfig = {
                onFiltered(filteredItems, selectedOptions) {
                    if (selectedOptions.length) vm.filteredOrganizationIds = _.map(filteredItems, 'id')
                    else vm.filteredOrganizationIds = organizationIds

                    syncAggregatedDataView()
                    $timeout()
                },
                filters: [
                    [{
                        headerTranslate: 'Industries',
                        filterOptionsSource(sourceArray) {
                            let output

                            output = _.chain(vm.industryRelations)
                                .groupBy('wfcid')
                                .mapValues((relations, industryWfid) => {
                                    const industry = vm.industryByWfid[industryWfid]
                                    const items = _.intersectionWith(organizations, relations, (org, relation) => {
                                        return org.id === relation.organizationId
                                    })

                                    return {
                                        content: industry,
                                        title: industry.title,
                                        id: industry.wfid,
                                        count: items.length,
                                        items,
                                    }
                                })
                                .map()
                                .value()

                            return output
                        },
                    },
                    ],
                ],
            }
        }

        function defineLookupObjects() {
            return $q((resolve) => {
                const
                    output = {}
					
                const promises = []
					
                let promise

                output.includeItemsInCategoryByWfid = {
                    '71-10520': true, // Foundation
                    '71-10521': false, // General Disclosures
                    '71-10522': false, // Management Approach
                    '71-10523': true, // Economic
                    '71-10524': true, // Environmental
                    '71-10525': true, // Social
                }

                output.griCodeByWfid = {
                    '71-10520': '101', // Foundation
                    '71-10521': '102', // General Disclosures
                    '71-10522': '103', // Management Approach
                    '71-10523': '200', // Economic
                    '71-10524': '300', // Environmental
                    '71-10525': '400', // Social
                }

                // Official colors
                output.griColorsByWfid = {
                    '71-10520': '#002C5C', // Foundation
                    '71-10521': '#0B406B', // General Disclosures
                    '71-10522': '#02528A', // Management Approach
                    '71-10523': '#732A82', // Economic
                    '71-10524': '#06966F', // Environmental
                    '71-10525': '#F36B21', // Social
                }

                // Our colors
                // output.griColorsByWfid = {
                // 	"71-10520": "#95A5A6", // Foundation
                // 	"71-10521": "#F9B331", // General Disclosures
                // 	"71-10522": "#c481ca", // Management Approach
                // 	"71-10523": "#3598DB", // Economic
                // 	"71-10524": "#2DCC70", // Environmental
                // 	"71-10525": "#E84C3D" // Social
                // };

                output.griCategoriesByWfid = {
                    '71-10520': 'Foundation',
                    '71-10521': 'General Disclosures',
                    '71-10522': 'Management Approach',
                    '71-10523': 'Economic',
                    '71-10524': 'Environmental',
                    '71-10525': 'Social',
                }

                output.griCategoryCssClassesByWfid = {
                    '71-10520': 'gri-foundation',
                    '71-10521': 'gri-general_disclosures',
                    '71-10522': 'gri-management_approach',
                    '71-10523': 'gri-economic',
                    '71-10524': 'gri-environmental',
                    '71-10525': 'gri-social',
                }

                output.totalCountByCatWfid = {
                    '71-10523': 31,
                    '71-10524': 54,
                    '71-10521': 56,
                    '71-10522': 3,
                    '71-10525': 91,
                }

                output.categoryWfidByGriWfid = {
                    '71-10658': '71-10522', '71-10659': '71-10522', '71-12105': '71-10522', '71-10539': '71-10521', '71-10540': '71-10521', '71-10541': '71-10521', '71-10542': '71-10521', '71-10543': '71-10521', '71-10544': '71-10521', '71-10545': '71-10521', '71-10547': '71-10521', '71-10548': '71-10521', '71-10549': '71-10521', '71-10550': '71-10521', '71-10551': '71-10521',
                    '71-10552': '71-10521', '71-10553': '71-10521', '71-10554': '71-10521', '71-10555': '71-10521', '71-10556': '71-10521', '71-10557': '71-10521', '71-10602': '71-10521', '71-10558': '71-10521', '71-10559': '71-10521', '71-10560': '71-10521', '71-10561': '71-10521', '71-10562': '71-10521', '71-10563': '71-10521', '71-10564': '71-10521', '71-10565': '71-10521', '71-10567': '71-10521',
                    '71-10568': '71-10521', '71-10569': '71-10521', '71-10570': '71-10521', '71-10571': '71-10521', '71-10572': '71-10521', '71-10573': '71-10521', '71-10574': '71-10521', '71-10575': '71-10521', '71-10576': '71-10521', '71-10577': '71-10521', '71-10578': '71-10521', '71-10579': '71-10521', '71-10580': '71-10521', '71-10581': '71-10521', '71-10582': '71-10521', '71-10583': '71-10521',
                    '71-10584': '71-10521', '71-10566': '71-10521', '71-10585': '71-10521', '71-10586': '71-10521', '71-10587': '71-10521', '71-10588': '71-10521', '71-10589': '71-10521', '71-10590': '71-10521', '71-10591': '71-10521', '71-10592': '71-10521', '71-10593': '71-10521', '71-10594': '71-10521', '71-10595': '71-10521', '71-10596': '71-10521', '71-10597': '71-10521', '71-10598': '71-10521',
                    '71-10599': '71-10521', '71-10600': '71-10521', '71-10664': '71-10523', '71-10665': '71-10523', '71-10666': '71-10523', '71-10667': '71-10523', '71-10668': '71-10523', '71-10669': '71-10523', '71-10710': '71-10524', '71-10711': '71-10524', '71-10712': '71-10524', '71-10713': '71-10524', '71-10714': '71-10524', '71-10715': '71-10524', '71-10716': '71-10524', '71-10717': '71-10524',
                    '71-11021': '71-10525', '71-11022': '71-10525', '71-11023': '71-10525', '71-11024': '71-10525', '71-11025': '71-10525', '71-11026': '71-10525', '71-11027': '71-10525', '71-11028': '71-10525', '71-11029': '71-10525', '71-11030': '71-10525', '71-11031': '71-10525', '71-11032': '71-10525', '71-11033': '71-10525', '71-11034': '71-10525', '71-11035': '71-10525', '71-11036': '71-10525',
                    '71-11037': '71-10525', '71-11038': '71-10525', '71-11039': '71-10525', '71-10670': '71-10523', '71-10671': '71-10523', '71-10680': '71-10523', '71-10681': '71-10523', '71-10686': '71-10523', '71-10687': '71-10523', '71-10692': '71-10523', '71-10693': '71-10523', '71-10696': '71-10523', '71-10697': '71-10523', '71-10705': '71-10523', '71-10706': '71-10523', '71-10718': '71-10524',
                    '71-10719': '71-10524', '71-10738': '71-10524', '71-10739': '71-10524', '71-10750': '71-10524', '71-10751': '71-10524', '71-10758': '71-10524', '71-10759': '71-10524', '71-10768': '71-10524', '71-10769': '71-10524', '71-10784': '71-10524', '71-10785': '71-10524', '71-10798': '71-10524', '71-10799': '71-10524', '71-10804': '71-10524', '71-10805': '71-10524', '71-11040': '71-10525',
                    '71-11041': '71-10525', '71-11057': '71-10525', '71-11058': '71-10525', '71-11063': '71-10525', '71-11064': '71-10525', '71-11082': '71-10525', '71-11083': '71-10525', '71-11094': '71-10525', '71-11095': '71-10525', '71-11104': '71-10525', '71-11105': '71-10525', '71-11110': '71-10525', '71-11111': '71-10525', '71-11116': '71-10525', '71-11117': '71-10525', '71-11123': '71-10525',
                    '71-11124': '71-10525', '71-11129': '71-10525', '71-11130': '71-10525', '71-11135': '71-10525', '71-11136': '71-10525', '71-11141': '71-10525', '71-11142': '71-10525', '71-11154': '71-10525', '71-11155': '71-10525', '71-11162': '71-10525', '71-11163': '71-10525', '71-11174': '71-10525', '71-11175': '71-10525', '71-11180': '71-10525', '71-11181': '71-10525', '71-11190': '71-10525',
                    '71-11191': '71-10525', '71-11204': '71-10525', '71-11205': '71-10525', '71-11211': '71-10525', '71-11212': '71-10525', '71-12759': '71-10523', '71-12760': '71-10523', '71-12761': '71-10523', '71-10674': '71-10523', '71-10673': '71-10523', '71-10675': '71-10523', '71-10676': '71-10523', '71-12762': '71-10523', '71-12763': '71-10523', '71-12764': '71-10523', '71-10682': '71-10523',
                    '71-10683': '71-10523', '71-12765': '71-10523', '71-12766': '71-10523', '71-12767': '71-10523', '71-10688': '71-10523', '71-10690': '71-10523', '71-12768': '71-10523', '71-12769': '71-10523', '71-12770': '71-10523', '71-10694': '71-10523', '71-12771': '71-10523', '71-12772': '71-10523', '71-12773': '71-10523', '71-10698': '71-10523', '71-10701': '71-10523', '71-10703': '71-10523',
                    '71-12774': '71-10523', '71-12775': '71-10523', '71-12776': '71-10523', '71-10707': '71-10523', '71-12777': '71-10524', '71-12778': '71-10524', '71-12779': '71-10524', '71-10720': '71-10524', '71-10722': '71-10524', '71-10724': '71-10524', '71-12780': '71-10524', '71-12781': '71-10524', '71-12782': '71-10524', '71-10740': '71-10524', '71-10742': '71-10524', '71-10744': '71-10524',
                    '71-10746': '71-10524', '71-10748': '71-10524', '71-12783': '71-10524', '71-12784': '71-10524', '71-12785': '71-10524', '71-10752': '71-10524', '71-10754': '71-10524', '71-10756': '71-10524', '71-12786': '71-10524', '71-12787': '71-10524', '71-12788': '71-10524', '71-10760': '71-10524', '71-10762': '71-10524', '71-10764': '71-10524', '71-10766': '71-10524', '71-12789': '71-10524',
                    '71-12790': '71-10524', '71-12791': '71-10524', '71-10770': '71-10524', '71-10772': '71-10524', '71-10774': '71-10524', '71-10776': '71-10524', '71-10778': '71-10524', '71-10780': '71-10524', '71-10782': '71-10524', '71-12792': '71-10524', '71-12793': '71-10524', '71-12794': '71-10524', '71-10786': '71-10524', '71-10793': '71-10524', '71-10789': '71-10524', '71-12168': '71-10524',
                    '71-12169': '71-10524', '71-12795': '71-10524', '71-12796': '71-10524', '71-12797': '71-10524', '71-10800': '71-10524', '71-12798': '71-10524', '71-12799': '71-10524', '71-12800': '71-10524', '71-10806': '71-10524', '71-10809': '71-10524', '71-12801': '71-10525', '71-12802': '71-10525', '71-12803': '71-10525', '71-11042': '71-10525', '71-11046': '71-10525', '71-11050': '71-10525',
                    '71-12804': '71-10525', '71-12805': '71-10525', '71-12806': '71-10525', '71-11059': '71-10525', '71-12807': '71-10525', '71-12808': '71-10525', '71-12809': '71-10525', '71-11065': '71-10525', '71-11070': '71-10525', '71-11078': '71-10525', '71-11075': '71-10525', '71-12810': '71-10525', '71-12811': '71-10525', '71-12812': '71-10525', '71-11084': '71-10525', '71-11087': '71-10525',
                    '71-11091': '71-10525', '71-12813': '71-10525', '71-12814': '71-10525', '71-12815': '71-10525', '71-11096': '71-10525', '71-11100': '71-10525', '71-12816': '71-10525', '71-12817': '71-10525', '71-12818': '71-10525', '71-11106': '71-10525', '71-12819': '71-10525', '71-12820': '71-10525', '71-12821': '71-10525', '71-11112': '71-10525', '71-12822': '71-10525', '71-12823': '71-10525',
                    '71-12824': '71-10525', '71-11118': '71-10525', '71-12825': '71-10525', '71-12826': '71-10525', '71-12827': '71-10525', '71-11125': '71-10525', '71-12828': '71-10525', '71-12829': '71-10525', '71-12830': '71-10525', '71-11131': '71-10525', '71-12831': '71-10525', '71-12832': '71-10525', '71-12833': '71-10525', '71-11137': '71-10525', '71-12834': '71-10525', '71-12835': '71-10525',
                    '71-12836': '71-10525', '71-11143': '71-10525', '71-11146': '71-10525', '71-11150': '71-10525', '71-12837': '71-10525', '71-12838': '71-10525', '71-12839': '71-10525', '71-11156': '71-10525', '71-11159': '71-10525', '71-12840': '71-10525', '71-12841': '71-10525', '71-12842': '71-10525', '71-11164': '71-10525', '71-11167': '71-10525', '71-12843': '71-10525', '71-12844': '71-10525',
                    '71-12845': '71-10525', '71-11176': '71-10525', '71-12846': '71-10525', '71-12847': '71-10525', '71-12848': '71-10525', '71-11183': '71-10525', '71-11186': '71-10525', '71-12849': '71-10525', '71-12850': '71-10525', '71-12851': '71-10525', '71-11192': '71-10525', '71-11196': '71-10525', '71-11200': '71-10525', '71-12852': '71-10525', '71-12853': '71-10525', '71-12854': '71-10525',
                    '71-11206': '71-10525', '71-12855': '71-10525', '71-12856': '71-10525', '71-12857': '71-10525', '71-11213': '71-10525', '71-10526': '71-10520', '71-12053': '71-10520', '71-12054': '71-10520', '71-10527': '71-10520', '71-10528': '71-10520', '71-12055': '71-10520', '71-12056': '71-10520', '71-12057': '71-10520', '71-12058': '71-10520', '71-12059': '71-10520', '71-12079': '71-10520',
                    '71-12081': '71-10520', '71-12085': '71-10520', '71-12086': '71-10520', '71-12865': '71-10520', '71-12866': '71-10520', '71-10529': '71-10520', '71-10530': '71-10520', '71-10531': '71-10520', '71-10538': '71-10520', '71-10532': '71-10520', '71-10533': '71-10520', '71-10534': '71-10520', '71-10535': '71-10520', '71-10536': '71-10520', '71-10537': '71-10520', '71-12060': '71-10520',
                    '71-12061': '71-10520', '71-12062': '71-10520', '71-12063': '71-10520', '71-12065': '71-10520', '71-12069': '71-10520', '71-12070': '71-10520', '71-12080': '71-10520', '71-12082': '71-10520', '71-12087': '71-10520', '71-12095': '71-10520', '71-12064': '71-10520', '71-12066': '71-10520', '71-12067': '71-10520', '71-12068': '71-10520', '71-12071': '71-10520', '71-12074': '71-10520',
                    '71-12083': '71-10520', '71-12084': '71-10520', '71-12088': '71-10520', '71-12089': '71-10520', '71-12090': '71-10520', '71-12091': '71-10520', '71-12092': '71-10520', '71-12096': '71-10520', '71-12097': '71-10520', '71-12072': '71-10520', '71-12073': '71-10520', '71-12075': '71-10520', '71-12076': '71-10520', '71-12077': '71-10520', '71-12078': '71-10520', '71-12093': '71-10520',
                    '71-12094': '71-10520',
                }

                output.sdgLinkageByGriWfid = {
                    '71-12169': ['71-458', '71-523', '71-532', '71-536'], '71-12168': ['71-429', '71-509'], '71-11213': ['71-546'], '71-11206': ['71-546', '71-553', '71-13260'], '71-11200': ['71-546'], '71-11196': ['71-546'], '71-11192': ['71-513'], '71-11186': ['71-546'], '71-11176': ['71-548'], '71-11167': ['71-445', '71-473', '71-544'], '71-11164': ['71-445', '71-473', '71-544'],
                    '71-11159': ['71-409', '71-415'], '71-11137': ['71-415'], '71-11131': ['71-544'], '71-11125': ['71-472'], '71-11118': ['71-472', '71-545'], '71-11112': ['71-473'], '71-11106': ['71-444', '71-473', '71-555'], '71-11100': ['71-444', '71-470', '71-13217'], '71-11096': ['71-444', '71-448', '71-470'], '71-11091': ['71-444', '71-470', '71-13217'], '71-11087': ['71-467', '71-470'],
                    '71-11084': ['71-436', '71-437', '71-438', '71-444', '71-467', '71-470', '71-13217'], '71-11078': ['71-473'], '71-11075': ['71-423', '71-424', '71-429', '71-473'], '71-11070': ['71-423', '71-424', '71-429', '71-473'], '71-11065': ['71-473'], '71-11059': ['71-473'], '71-11050': ['71-444', '71-447', '71-470'], '71-11046': ['71-447', '71-470', '71-13130'],
                    '71-11042': ['71-444', '71-470', '71-471', '71-13217'], '71-10800': ['71-546'], '71-10793': ['71-429', '71-455', '71-509', '71-510'], '71-10789': ['71-429', '71-455', '71-458', '71-509', '71-522', '71-532'], '71-10786': ['71-429', '71-455', '71-456', '71-458', '71-509', '71-522'], '71-10782': ['71-429', '71-509', '71-524', '71-533'],
                    '71-10780': ['71-429', '71-509'], '71-10778': ['71-517', '71-524', '71-533'], '71-10776': ['71-517', '71-524', '71-533'], '71-10774': ['71-429', '71-509', '71-517', '71-524', '71-533'], '71-10772': ['71-429', '71-509', '71-517', '71-524', '71-533'], '71-10770': ['71-429', '71-509', '71-517', '71-524', '71-533'], '71-10766': ['71-458', '71-523', '71-532', '71-535', '71-536'],
                    '71-10764': ['71-458', '71-523', '71-532', '71-535', '71-536'], '71-10762': ['71-458', '71-523', '71-532', '71-535', '71-536'], '71-10760': ['71-458', '71-523', '71-532', '71-535', '71-536'], '71-10756': ['71-455', '71-456', '71-469', '71-507'], '71-10754': ['71-456'], '71-10752': ['71-456'], '71-10748': ['71-463', '71-469', '71-507', '71-517'],
                    '71-10746': ['71-463', '71-469', '71-507', '71-517'], '71-10744': ['71-463', '71-469', '71-507', '71-517'], '71-10742': ['71-462', '71-463', '71-469', '71-507', '71-517'], '71-10740': ['71-462', '71-463', '71-469', '71-507', '71-517'], '71-10724': ['71-469', '71-507', '71-510'], '71-10722': ['71-469', '71-507', '71-510'],
                    '71-10720': ['71-469', '71-507'], '71-10707': ['71-546'], '71-10703': ['71-548'], '71-10701': ['71-548'], '71-10698': ['71-548'], '71-10694': ['71-468'], '71-10690': ['71-407', '71-415', '71-428', '71-467', '71-468', '71-470', '71-494', '71-558'], '71-10688': ['71-418', '71-447', '71-464', '71-465', '71-478', '71-481', '71-483', '71-497'],
                    '71-10683': ['71-470'], '71-10682': ['71-407', '71-444', '71-470'], '71-10674': ['71-418', '71-447', '71-464', '71-465', '71-466', '71-467', '71-478', '71-481', '71-482', '71-483'], '71-10673': ['71-517'], '71-10582': ['71-550'], '71-10574': ['71-550'], '71-10572': ['71-440'], '71-10570': ['71-549'], '71-10569': ['71-448', '71-550'],
                    '71-10568': ['71-549'], '71-10567': ['71-448', '71-550'], '71-10566': ['71-473'], '71-10565': ['71-550'], '71-10561': ['71-546'], '71-10560': ['71-546'], '71-10552': ['71-470', '71-13217'],
                }

                output.sdgCategoriesByWfid = {
                    '71-389': null,
                    '71-391': null,
                    '71-388': null,
                    '71-393': null,
                    '71-395': null,
                    '71-396': null,
                    '71-397': null,
                    '71-398': null,
                    '71-399': null,
                    '71-400': null,
                    '71-401': null,
                    '71-403': null,
                    '71-402': null,
                    '71-394': null,
                    '71-392': null,
                    '71-390': null,
                    '71-404': null,
                }

                output.categoryWfidBySdgWfid = {
                    '71-418': '71-389', '71-415': '71-389', '71-13123': '71-389', '71-10367': '71-389', '71-10368': '71-389', '71-13127': '71-389', '71-10369': '71-389', '71-13330': '71-389', '71-13138': '71-391', '71-13139': '71-391', '71-436': '71-391', '71-437': '71-391', '71-438': '71-391', '71-13140': '71-391', '71-440': '71-391', '71-13195': '71-391', '71-13196': '71-391', '71-13197': '71-391',
                    '71-406': '71-388', '71-409': '71-388', '71-407': '71-388', '71-13119': '71-388', '71-13120': '71-388', '71-13121': '71-388', '71-13122': '71-388', '71-456': '71-393', '71-458': '71-393', '71-455': '71-393', '71-10370': '71-393', '71-13204': '71-393', '71-13205': '71-393', '71-13206': '71-393', '71-10371': '71-393', '71-466': '71-395', '71-13210': '71-395', '71-467': '71-395',
                    '71-468': '71-395', '71-469': '71-395', '71-470': '71-395', '71-471': '71-395', '71-472': '71-395', '71-473': '71-395', '71-13209': '71-395', '71-13211': '71-395', '71-13212': '71-395', '71-478': '71-396', '71-13213': '71-396', '71-13214': '71-396', '71-481': '71-396', '71-482': '71-396', '71-483': '71-396', '71-13215': '71-396', '71-13216': '71-396', '71-486': '71-397',
                    '71-487': '71-397', '71-13217': '71-397', '71-13218': '71-397', '71-13219': '71-397', '71-13220': '71-397', '71-13221': '71-397', '71-13222': '71-397', '71-494': '71-397', '71-13223': '71-397', '71-497': '71-398', '71-13224': '71-398', '71-13225': '71-398', '71-13226': '71-398', '71-13227': '71-398', '71-10372': '71-398', '71-13229': '71-398', '71-13230': '71-398',
                    '71-13231': '71-398', '71-10373': '71-398', '71-10374': '71-399', '71-507': '71-399', '71-10375': '71-399', '71-509': '71-399', '71-510': '71-399', '71-10376': '71-399', '71-512': '71-399', '71-513': '71-399', '71-10387': '71-399', '71-13237': '71-399', '71-13238': '71-399', '71-517': '71-400', '71-981': '71-400', '71-10377': '71-400', '71-10378': '71-400', '71-13241': '71-400',
                    '71-522': '71-401', '71-523': '71-401', '71-524': '71-401', '71-10379': '71-401', '71-13243': '71-401', '71-13244': '71-401', '71-13245': '71-401', '71-13246': '71-401', '71-13247': '71-401', '71-13248': '71-401', '71-544': '71-403', '71-545': '71-403', '71-546': '71-403', '71-548': '71-403', '71-549': '71-403', '71-550': '71-403', '71-553': '71-403', '71-555': '71-403',
                    '71-13257': '71-403', '71-13258': '71-403', '71-13259': '71-403', '71-13260': '71-403', '71-533': '71-402', '71-536': '71-402', '71-535': '71-402', '71-532': '71-402', '71-10380': '71-402', '71-13250': '71-402', '71-10381': '71-402', '71-10382': '71-402', '71-10384': '71-402', '71-10385': '71-402', '71-10383': '71-402', '71-13256': '71-402', '71-13208': '71-394',
                    '71-462': '71-394', '71-463': '71-394', '71-464': '71-394', '71-465': '71-394', '71-444': '71-392', '71-445': '71-392', '71-13198': '71-392', '71-447': '71-392', '71-448': '71-392', '71-13199': '71-392', '71-13200': '71-392', '71-13201': '71-392', '71-13202': '71-392', '71-423': '71-390', '71-429': '71-390', '71-424': '71-390', '71-428': '71-390', '71-13129': '71-390',
                    '71-13130': '71-390', '71-13131': '71-390', '71-13132': '71-390', '71-13134': '71-390', '71-13136': '71-390', '71-13135': '71-390', '71-13133': '71-390', '71-13137': '71-390', '71-13261': '71-404', '71-13262': '71-404', '71-558': '71-404', '71-13263': '71-404', '71-13264': '71-404', '71-13269': '71-404', '71-562': '71-404', '71-13270': '71-404', '71-13271': '71-404',
                    '71-13272': '71-404', '71-13273': '71-404', '71-13274': '71-404', '71-13276': '71-404', '71-13277': '71-404', '71-13278': '71-404', '71-10386': '71-404', '71-13280': '71-404', '71-13281': '71-404', '71-13282': '71-404' }

                promise = dataOps.getObjects(_.keys(output.sdgCategoriesByWfid), { cacheResponse: false })
                promise.then((res) => {
                    output.sdgCategoriesByWfid = _.chain(res).keyBy('wfid').mapValues((sdgGoal) => {
                        const title = sdgGoal.title

                        // Extract part "Goal X" from the title
                        // title = title.substring(0, title.indexOf(" - "));

                        return {
                            title,
                            wfid: sdgGoal.wfid,
                            type: sdgGoal.type,
                            hasImage: sdgGoal.hasImage,
                            imageUrl: sdgGoal.imageUrl,
                        }
                    }).value()
                })
                promises.push(promise)

                promise = initializeIndustries()
                promise.then(() => {
                    output.industriesByOrgId = _.mapValues(vm.industriesByOrgId, (relations) => {
                        return _.map(relations, 'childContent')
                    })
                })
                promises.push(promise)

                $q.all(promises).then(() => {
                    lookups = output
                    resolve()
                })
            })
        }

        function initializeIndustries() {
            let promise

            promise = apiProxy.raw('multi.getSubItems', {
                item: { id: 14409, type: enums.objectType.structure },
                ticket: {
                    networkId,
                    organizationIds,
                },
                kind: enums.subItemsKind.childrenByUser,
                culture: wfAuth.getCulture(),
                loadParents: false,
                loadMetadata: false,
                loadVisibilityTags: false,
                getterConditions: {
                    loadCreators: false,
                    includeOrganizations: false,
                },
                bypassCache: true,
            }).then((industryRelations) => {
                const contentByWfid = _.chain(industryRelations).map('childContent').compact().keyBy('wfid').value()

                vm.industryRelations = industryRelations
                vm.industryByWfid = contentByWfid
                _.each(industryRelations, (relation) => {
                    relation.childContent = contentByWfid[relation.wfcid]
                })

                syncIndustries()
                $timeout()
            })

            return promise
        }
		
        function syncIndustries() {
            let orgIndustryRelations
			
            vm.industriesByOrgId = _.groupBy(vm.industryRelations, 'organizationId')
            // vm.industriesHtmlByOrgId = _.mapValues(vm.industriesByOrgId, function (relations) {
            // 	return _.map(relations, function (relation) {
            // 		var title = $sanitize(relation.childContent.title);
            // 		return industryItemInterpolate({
            // 			title: title,
            // 			tooltipText: $translate.instant("Industry") + ": " + title
            // 		});
            // 	}).join("");
            // });
        }

        function natsort(options) {

            options = options || {}
	
            const GREATER = options.desc ? -1 : 1
            const SMALLER = -GREATER
	
            const ore = /^0/
            const sre = /\s+/g
            const tre = /^\s+|\s+$/g
            // unicode
            const ure = /[^\x00-\x80]/
            // hex
            const hre = /^0x[0-9a-f]+$/i
            // numeric
            // var nre = /(^([+\-]?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?(?=\D|\s|$))|^0x[\da-fA-F]+$|\d+)/g;
            const nre = /(0x[\da-fA-F]+|(^[\+\-]?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?(?=\D|\s|$))|\d+)/g
            // datetime
            const dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/
	
            const normalize = options.insensitive ?
                function (s) {
                    return lowerCase('' + s).replace(tre, '')
                } :
                function (s) {
                    return ('' + s).replace(tre, '')
                }
	
            function lowerCase(s) {
                if (s.toLocaleLowerCase) {
                    return s.toLocaleLowerCase()
                }
                return s.toLowerCase()
            }
	
            function tokenize(s) {
                return s.replace(nre, '\0$1\0')
                    .replace(/\0$/, '')
                    .replace(/^\0/, '')
                    .split('\0')
            }
	
            function parse(s, l) {
                // normalize spaces; find floats not starting with '0',
                // string or 0 if not defined (Clint Priest)
                return (!s.match(ore) || l === 1)
					&& parseFloat(s)
					|| s.replace(sre, ' ').replace(tre, '')
					|| 0
            }
	
            return function (a, b) {
	
                // trim pre-post whitespace
                const x = normalize(a)
                const y = normalize(b)
	
                // return immediately if at least one of the values is empty.
                // - empty string < any others
                if (!x && !y) {
                    return 0
                }
	
                if (!x && y) {
                    return SMALLER
                }
	
                if (x && !y) {
                    return GREATER
                }
	
                // tokenize: split numeric strings and default strings
                const xArr = tokenize(x)
                const yArr = tokenize(y)
	
                // hex or date detection
                const xD = parseInt(x.match(hre), 16) || (xArr.length !== 1 && Date.parse(x))
                const yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null
	
                // try and sort Hex codes or Dates
                if (yD) {
                    if (xD < yD) {
                        return SMALLER
                    } else if (xD > yD) {
                        return GREATER
                    }
                }
	
                //console.log('x: ' + xArr.join('@'));
                //console.log('y: ' + yArr.join('@'));
	
                const xL = xArr.length
                const yL = yArr.length
	
                // handle numeric strings and default strings
                for (let i = 0, l = Math.max(xL, yL); i < l; i++) {
	
                    const xF = parse(xArr[i] || '', xL)
                    const yF = parse(yArr[i] || '', yL)
	
                    //console.log('xF: ' + xF);
                    //console.log('yF: ' + yF);
	
                    // handle numeric vs string comparison
                    // - numeric < string - (Kyle Adams)
                    if (isNaN(xF) !== isNaN(yF)) {
                        return isNaN(xF) ? GREATER : SMALLER
                    }
	
                    // if unicode use locale comparison
                    if (ure.test(xF + yF) && xF.localeCompare) {
                        const comp = xF.localeCompare(yF)
	
                        if (comp > 0) {
                            return GREATER
                        } else if (comp < 0) {
                            return SMALLER
                        } else {
                            if (i === l - 1) {
                                return 0
                            } else {
                                continue
                            }
                        }
                    }
	
                    if (xF < yF) {
                        return SMALLER
                    } else if (xF > yF) {
                        return GREATER
                    }
                }
	
                return 0
            }
        }

        function toggleLoaderBar() {
            vm.loaderBarShown = !vm.loaderBarShown
            $('body').toggleClass('lift-intercom-button')
        }

        function checkIfItemsBelongToScopeCategory() {
            if (!vm.scopeCategoryRelations) {
                dataOps.getSubItems(vm.scopeCategoryWfid, vm.scopeCategorySubItemsKind, { ticket: vm.ticket }).then(() => {
                    if (vm.ticket) delete vm.ticket.networkId

                    vm.scopeCategoryRelations = dataQuery.getIntersectedSubItems(vm.scopeCategoryWfid, _.assign({
                        parentType: enums.objectType.structure,
                        kind: vm.scopeCategorySubItemsKind,
                    }, vm.ticket || { organizationId: wfAuth.getOrganizationId() }))
                    compareItemsFromScope()
                })
                // dataOps.getObject(scopeCategoryWfid, {  ticket: vm.ticket }).then(function(scopeCategoryStructure) {
                // 	vm.scopeCategoryStructure = scopeCategoryStructure;
                // 	compareItemsFromScope();
                // });
            }
            else compareItemsFromScope()
        }

        function compareItemsFromScope() {
            if (vm.negotiator.items && vm.negotiator.items.length > 0 && vm.scopeCategoryRelations) {
                _.intersectionWith(vm.negotiator.items, vm.scopeCategoryRelations, (item1, item2) => {
                    let lookupArray

                    if (item1.wfid === item2.wfcid) {
                        item1.addedToScope = true
                        return item1
                    }
                    else if (vm.scopeCategoryLookup && item2.wfcid in vm.scopeCategoryLookup) {
                        lookupArray = vm.scopeCategoryLookup[item2.wfcid]
                        if (lookupArray.indexOf(item1.id) != -1) {
                            item1.addedToScope = true
                            return item1
                        }
                    }
                })
            }

            vm.itemsComparedWithScope = true
            $timeout()
        }

        function addOrRemoveFromScopeCategory(itemComposite) {
            if (!vm.disableAddingToScope) {
                if (itemComposite.addedToScope) removeFromScopeCategory(itemComposite)
                else addToScopeCategory(itemComposite)
            }
        }

        function addToScopeCategory(itemComposite) {
            itemComposite.addingToScope = true
            dataOps.createSubItemRelation(itemComposite.content, vm.scopeCategoryWfid, enums.subItemsKind.parentsByUser).then((res) => {
                vm.scopeCategoryRelations.push(res)
                compareItemsFromScope()
                itemComposite.addingToScope = false
            })
        }

        function removeFromScopeCategory(itemComposite) {
            const itemFromScopeToRemove = _.find(vm.scopeCategoryRelations, { wfcid: itemComposite.wfid })
			
            if (itemFromScopeToRemove && !_.isEmpty(itemFromScopeToRemove)) {
                itemComposite.addingToScope = true
                dataOps.destroy(itemFromScopeToRemove).then(() => {
                    _.remove(vm.scopeCategoryRelations, itemFromScopeToRemove)
                    itemComposite.addedToScope = false
                    compareItemsFromScope()
                    itemComposite.addingToScope = false
                })
            }
            else {
                console.error('Could not find an item to remove from the scope')
            }
        }
    }
})()
